import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";

const CcbpHistory = ({ mid }) => {
  const { callApi: ccbphistory } = useApi(
    "/creditCard/txn/history",
    "GET"
  );

  const today = new Date().toISOString().split("T")[0];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  // 🔥 FETCH API
  const fetchCcbpHistory = async (fDate = fromDate, tDate = toDate) => {
    try {
      setLoading(true);

      const res = await ccbphistory(
        null,
        `?merchant_user_name=${mid}&fromDate=${fDate}&toDate=${tDate}`
      );

      const finalData = Array.isArray(res) ? res : (res ? [res] : []);
      setData(finalData);

    } catch (err) {
      console.error("CCBP History Error:", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // 👉 DEFAULT LOAD
  useEffect(() => {
    if (mid) fetchCcbpHistory(today, today);
  }, [mid]);

  // 🔘 APPLY
  const handleApply = () => {
    fetchCcbpHistory(fromDate, toDate);
  };

  // 🔄 RESET
  const handleReset = () => {
    setFromDate(today);
    setToDate(today);
    fetchCcbpHistory(today, today);
  };

  return (
    <div className="bg-white rounded-xl shadow border p-4 mt-5">

      {/* 🔥 FILTER */}
      <div className="flex flex-wrap gap-3 items-end mb-4">

        <div>
          <label className="text-xs text-gray-500">From</label>
          <input
            type="date"
            value={fromDate}
            max={today}
            onChange={(e) => setFromDate(e.target.value)}
            className="border rounded px-2 py-1 text-sm"
          />
        </div>

        <div>
          <label className="text-xs text-gray-500">To</label>
          <input
            type="date"
            value={toDate}
            max={today}
            onChange={(e) => setToDate(e.target.value)}
            className="border rounded px-2 py-1 text-sm"
          />
        </div>

        <button
          onClick={handleApply}
          className="bg-blue-600 text-white px-4 py-1 rounded text-sm"
        >
          Apply
        </button>

        <button
          onClick={handleReset}
          className="bg-gray-200 px-4 py-1 rounded text-sm"
        >
          Reset
        </button>

      </div>

      {/* 🔥 TABLE */}
      {loading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : data.length === 0 ? (
        <p className="text-center text-gray-500">No Data Found</p>
      ) : (
        <div className="overflow-auto max-h-[400px] border rounded-lg">

          <table className="w-full text-sm border">

            <thead className="bg-gray-100 sticky top-0">
              <tr>
                <th className="p-2 border text-left">Details</th>
                <th className="p-2 border">Txn Amt</th>
                <th className="p-2 border">Net Amt</th>
                <th className="p-2 border">Ref No</th>
                <th className="p-2 border">Status</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, i) => (
                <tr key={i} className="border-b">

                  {/* ✅ DETAILS */}
                  <td className="p-2 border">

                    {/* LINE 1 */}
                    <div className="flex justify-between">
                      <span className="font-medium">
                        {item.txnId || "-"}
                      </span>

                      <span className="text-xs text-gray-500">
                        {item.date
                          ? new Date(item.date).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-"}
                      </span>
                    </div>

                    {/* LINE 2 */}
                    <div className="text-xs text-gray-600">
                      Consumer: {item.consumer_number || "-"}
                    </div>

                  </td>

                  {/* TXN AMOUNT */}
                  <td className="text-center border font-medium">
                    ₹{item.txnAmount ? Number(item.txnAmount).toFixed(2) : "0.00"}
                  </td>

                  {/* NET AMOUNT */}
                  <td className="text-center border font-medium">
                    ₹{item.netAmount ? Number(item.netAmount).toFixed(2) : "0.00"}
                  </td>

                  {/* EXTERNAL REF */}
                  <td className="text-center border text-xs">
                    {item.external_ref_no || "-"}
                  </td>

                  {/* STATUS */}
                  <td className="text-center border">
                    <span
                      className={`px-2 py-1 rounded text-xs font-semibold ${
                        item.txnStatus === "SUCCESS"
                          ? "bg-green-100 text-green-700"
                          : item.txnStatus === "PENDING"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {item.txnStatus || "-"}
                    </span>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>

        </div>
      )}
    </div>
  );
};

export default CcbpHistory;